import React, { useState, useEffect } from "react";
import { fetchCases } from "../services/api";
import { useNavigate } from "react-router-dom";

function Dashboard({ onLogout }) {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    loadCases();
  }, []);

  const loadCases = async () => {
    try {
      setLoading(true);
      const response = await fetchCases();
      setCases(response.data);
    } catch (error) {
      console.error("Error fetching cases:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredCases = cases.filter(caseItem => {
    // Filter by type
    const typeMatch = filter === "all" || caseItem.type === filter;
    
    // Filter by search term (case number, URL, or type)
    const searchMatch = searchTerm === "" || 
      (caseItem.caseNumber && caseItem.caseNumber.includes(searchTerm)) ||
      (caseItem.url && caseItem.url.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (caseItem.type && caseItem.type.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return typeMatch && searchMatch;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending": return "text-yellow-600 bg-yellow-100";
      case "Notice Sent": return "text-blue-600 bg-blue-100";
      case "Removed": return "text-green-600 bg-green-100";
      default: return "text-gray-600 bg-gray-100";
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case "malware": return "text-red-600 bg-red-100";
      case "phishing": return "text-orange-600 bg-orange-100";
      case "ncc": return "text-purple-600 bg-purple-100";
      case "spy-app": return "text-pink-600 bg-pink-100";
      default: return "text-gray-600 bg-gray-100";
    }
  };

  const getStats = () => {
    const total = cases.length;
    const malware = cases.filter(c => c.type === "malware").length;
    const phishing = cases.filter(c => c.type === "phishing").length;
    const ncc = cases.filter(c => c.type === "ncc").length;
    const spyApp = cases.filter(c => c.type === "spy-app").length;
    
    return { total, malware, phishing, ncc, spyApp };
  };

  const stats = getStats();

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      {/* Header */}
      <div style={{ 
        backgroundColor: "white", 
        padding: "1rem 2rem", 
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        borderBottom: "1px solid #e9ecef"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h1 style={{ margin: 0, fontSize: "1.5rem", color: "#333" }}>
            Digital Safe India - Dashboard
          </h1>
          <div style={{ display: "flex", gap: "1rem" }}>
            <a 
              href="/tools" 
              style={{
                backgroundColor: "#17a2b8",
                color: "white",
                textDecoration: "none",
                padding: "0.5rem 1rem",
                borderRadius: "4px"
              }}
            >
              🏠 Tools Dashboard
            </a>
            <a 
              href="/new-case" 
              style={{
                backgroundColor: "#007bff",
                color: "white",
                textDecoration: "none",
                padding: "0.5rem 1rem",
                borderRadius: "4px"
              }}
            >
              📝 New Case
            </a>
            <button
              onClick={onLogout}
              style={{
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      <div style={{ padding: "2rem" }}>
        {/* Stats Cards */}
        <div style={{ 
          display: "grid", 
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", 
          gap: "1rem", 
          marginBottom: "2rem" 
        }}>
          <div style={{ backgroundColor: "white", padding: "1.5rem", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <h3 style={{ margin: "0 0 0.5rem 0", color: "#333", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              📊 Total Cases
            </h3>
            <p style={{ margin: 0, fontSize: "2rem", fontWeight: "bold", color: "#007bff" }}>{stats.total}</p>
          </div>
          <div style={{ backgroundColor: "white", padding: "1.5rem", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <h3 style={{ margin: "0 0 0.5rem 0", color: "#333", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              🦠 Malware
            </h3>
            <p style={{ margin: 0, fontSize: "2rem", fontWeight: "bold", color: "#dc3545" }}>{stats.malware}</p>
          </div>
          <div style={{ backgroundColor: "white", padding: "1.5rem", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <h3 style={{ margin: "0 0 0.5rem 0", color: "#333", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              🎣 Phishing
            </h3>
            <p style={{ margin: 0, fontSize: "2rem", fontWeight: "bold", color: "#fd7e14" }}>{stats.phishing}</p>
          </div>
          <div style={{ backgroundColor: "white", padding: "1.5rem", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <h3 style={{ margin: "0 0 0.5rem 0", color: "#333", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              🔒 NCC
            </h3>
            <p style={{ margin: 0, fontSize: "2rem", fontWeight: "bold", color: "#6f42c1" }}>{stats.ncc}</p>
          </div>
          <div style={{ backgroundColor: "white", padding: "1.5rem", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <h3 style={{ margin: "0 0 0.5rem 0", color: "#333", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              👁️ Spy-App
            </h3>
            <p style={{ margin: 0, fontSize: "2rem", fontWeight: "bold", color: "#e83e8c" }}>{stats.spyApp}</p>
          </div>
        </div>

        {/* Filter and Table */}
        <div style={{ backgroundColor: "white", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", overflow: "hidden" }}>
          {/* Filter Bar */}
          <div style={{ padding: "1rem", borderBottom: "1px solid #e9ecef", backgroundColor: "#f8f9fa" }}>
            <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
              <span style={{ fontWeight: "bold" }}>Filter by type:</span>
              <select 
                value={filter} 
                onChange={(e) => setFilter(e.target.value)}
                style={{ 
                  padding: "0.5rem", 
                  border: "1px solid #ddd", 
                  borderRadius: "4px",
                  backgroundColor: "white"
                }}
              >
                <option value="all">All Types</option>
                <option value="malware">Malware</option>
                <option value="phishing">Phishing</option>
                <option value="ncc">NCC</option>
                <option value="spy-app">Spy App</option>
              </select>
              <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", marginLeft: "1rem" }}>
                <span style={{ fontWeight: "bold" }}>Search:</span>
                <input
                  type="text"
                  placeholder="Case #, URL, or type..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    padding: "0.5rem",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    minWidth: "200px"
                  }}
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm("")}
                    style={{
                      backgroundColor: "#6c757d",
                      color: "white",
                      border: "none",
                      padding: "0.5rem",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "0.8rem"
                    }}
                  >
                    Clear
                  </button>
                )}
              </div>
              <button 
                onClick={loadCases}
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  padding: "0.5rem 1rem",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
              >
                🔄 Refresh
              </button>
            </div>
          </div>

          {/* Table */}
          <div style={{ overflowX: "auto" }}>
            {loading ? (
              <div style={{ padding: "2rem", textAlign: "center" }}>Loading cases...</div>
            ) : filteredCases.length === 0 ? (
              <div style={{ padding: "2rem", textAlign: "center", color: "#666" }}>
                No cases found. <a href="/new-case" style={{ color: "#007bff" }}>Report your first case</a>
              </div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <th style={{ padding: "1rem", textAlign: "left", borderBottom: "1px solid #e9ecef" }}>Case #</th>
                    <th style={{ padding: "1rem", textAlign: "left", borderBottom: "1px solid #e9ecef" }}>Type</th>
                    <th style={{ padding: "1rem", textAlign: "left", borderBottom: "1px solid #e9ecef" }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCases.map((caseItem) => (
                    <tr key={caseItem._id} style={{ borderBottom: "1px solid #f1f3f4" }}>
                      <td style={{ padding: "1rem" }}>
                        {caseItem.caseNumber ? (
                          <button
                            onClick={() => navigate(`/case/${caseItem.caseNumber}`)}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#007bff",
                              fontSize: "1rem",
                              fontWeight: "bold",
                              cursor: "pointer",
                              textDecoration: "underline",
                              padding: 0
                            }}
                            onMouseOver={(e) => e.target.style.color = "#0056b3"}
                            onMouseOut={(e) => e.target.style.color = "#007bff"}
                          >
                            #{caseItem.caseNumber}
                          </button>
                        ) : (
                          <span style={{ color: "#999" }}>N/A</span>
                        )}
                      </td>
                      <td style={{ padding: "1rem" }}>
                        <span style={{ 
                          padding: "0.25rem 0.5rem", 
                          borderRadius: "12px", 
                          fontSize: "0.875rem", 
                          fontWeight: "500",
                          textTransform: "capitalize"
                        }} className={getTypeColor(caseItem.type)}>
                          {caseItem.type}
                        </span>
                      </td>
                      <td style={{ padding: "1rem", color: "#666" }}>
                        {new Date(caseItem.createdAt).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
